import { IHistory, IUrl, IUrlService } from './types';
import { IUrlFactory } from './UrlFactory';

export class BrowserUrlService implements IUrlService {
    constructor(
        private urlFactory: IUrlFactory,
        private history: IHistory,
    ) {}

    updateUrl(url: IUrl): void {
        this.history.replaceState(url);
    }

    pushUrl(url: IUrl): void {
        this.history.pushState(url);
    }

    createUrl(url?: string): IUrl {
        return this.urlFactory.createUrl(this, url);
    }
}
